'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'bell-concierge';
var width = 512;
var height = 512;
var aliases = [128718,"concierge-bell"];
var unicode = 'f562';
var svgPathData = ['M64 368l384 0c0-106-86-192-192-192S64 262 64 368z', 'M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 48.6C123.8 152.8 32 249.7 32 368l32 0c0-106 86-192 192-192s192 86 192 192l32 0c0-118.3-91.8-215.2-208-223.4l0-48.6 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 416z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBellConcierge = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;